import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import nestApiService from 'services/api/nest-api-service'

export interface SubscriptionsState {
  isLoading: boolean
  packageSubscriptions: PackageSubscription[]
}

const initialState: SubscriptionsState = {
  isLoading: false,
  packageSubscriptions: []
}

export const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    resetPackageSubscriptionsState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getPackageSubscriptions.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPackageSubscriptions.fulfilled, (state, { payload }) => {
        state.isLoading = false
        state.packageSubscriptions = payload
      })
      .addCase(getPackageSubscriptions.rejected, (state) => {
        state.isLoading = false
        state.packageSubscriptions = []
      })
})

export const { resetPackageSubscriptionsState } = subscriptionsSlice.actions

export default subscriptionsSlice.reducer

interface GetPackageSubscriptionsParams {
  userId: number
}

export const getPackageSubscriptions = createAsyncThunk(
  'get-package-subscriptions',
  async ({ userId }: GetPackageSubscriptionsParams, { rejectWithValue }) => {
    try {
      const { data } = await nestApiService.apiInstance.get<PackageSubscription[]>(`/packages/subscriptions/${userId}`)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

export interface PackageSubscription {
  packageSubscriptionId: number
  packageOrderId: number
  prescriptionId: number
  price: number
  deliveryPrice: number | null
  planType: SubscriptionRecurrence
  installments: number
  firstPaymentAt: string
  nextPaymentAt: null | string
  failedAt: null | string
  failedAttempts: number
  nextRetryDate: null | string
  planEndedAt: null | string
  psychologyCredits: number | null
  products: string[]
}

export type SubscriptionRecurrence = 'monthly' | 'quarterly' | 'bimonthly'
export const subscriptionRecurrenceOptions: SubscriptionRecurrence[] = ['monthly', 'quarterly', 'bimonthly']
